<template>
  <div style="margin-bottom: 10px; text-align: left">
    <el-button type="primary" @click="createVisible = true">创建入库单</el-button>
    <createInbound :visible="createVisible" @submit="$emit('refresh');createVisible=false" @close="createVisible=false"></createInbound>
  </div>
</template>

<script>

import Calendar from "@/utils/calendar";
import createInbound from "./createInbound.vue";
import store from "@/store";
export default {
  name: "InterBtnBox",
  components:{createInbound},
  data() {
    return {
      createVisible: false
    };
  },
  props: {
  },
  computed: {
  },
  methods: {
  },
};
</script>

<style scoped>

.dialogTitle{
  height: 60px;
  width: 100%;
  font-size: 20px;
  text-align: center;
  line-height: 60px;
  background-color: #00284d;
  color: #e8e8e8;
}

</style>
